export const Icons = {
  MANAGER: "user",
  POSITION: "briefcase",
  AREA: "sitemap",
  PARENT_AREA: "sitemap",
  EMAIL: "at",
  CPF: "id card",
  CODE: "id card",
  NAME: "id card",
  COMPANY: "building outline",
  CATEGORY: "tag",
  DESCRIPTION: "info circle",
  EMPLOYEE_COUNT: "users",
  ALL_DONE: "clipboard check",
  SINCE: "calendar alternate outline",
  SENIORITY_LEVEL: "certificate",
  SALARY_RANGE: "money bill alternate"
};
